module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    attrs: {
      "tag": "li",
      "to": _vm.href,
      "active-class": "active",
      "exact": ""
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.href
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.title))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-602593c5","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar/item.vue
// module id = F9IZ
// module chunks = 13 14